import React, { useCallback, useEffect, useMemo } from 'react';
import TrainingProgramsApi from '../TrainingProgramsApi';

import FieldSelect from '@dex/bubl-dash/src/lib/components/Fields/FieldSelect';
import { Form, useForm } from '@dex/bubl-dash/src/lib/functions/useForm';
import Sort from '@dex/bubl-dash/src/lib/components/Sort/Sort';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import { Box } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Loading from '@dex/bubl-dash/src/lib/components/Loading/Loading';
import { useApp } from '@dex/bubl-dash/src/lib/functions/useApp';
import FieldRelationship from '@dex/bubl-dash/src/lib/components/Fields/FieldRelationship';

const TrainingProgramsSort: React.FC<any> = (props: any) => {

    const app = useApp();

    const form = useForm();

    const pages = TrainingProgramsApi.get();

    const save = TrainingProgramsApi.create({}, "reorder");

    useEffect(() => {

        if (!form.values.activityId) return;

        const params: any = { where: { activityId: form.values.activityId }, include: [], order: ["order ASC"], limit: 1000 };

        pages.reset();
        pages.cancel();

        pages.run({
            params: params
        });

    }, [form.values.activityId]);

    const handleSave = useCallback((data) => {

        save.run({
            data: { rows: data },
            onComplete: (response: any) => {

                app.alert(response, 'success');

            }
        });

    }, []);

    return useMemo(() => (

        <Box gutter={"auto"}>

            <Panel
                heading={"Re-Order"}
            >

                <Form
                    form={form}
                >

                    <FieldRelationship
                        form={form}
                        label={"Sport / Activity"}
                        name='activityId'
                        isMulti={false}
                        required={true}
                        preload={true}
                        endpoint={'SportsActivities'}
                        defaultValue={form.defaults.activityId}
                    />

                </Form>

                {pages.loading &&
                    <Box gutter={"auto"}>
                        <br />
                        <Loading />
                    </Box>
                }

                {pages.data && pages.data.data && pages.data.data.length > 0 &&

                    <Sort
                        data={pages.data.data}
                        // parentIdKey={"parentId"}
                        preSorted={true}
                        maxDepth={1}
                        handleSave={handleSave}
                        loading={save.loading}
                    />

                }

            </Panel>

        </Box>

    ), [form.values, pages.loading, save.loading]);

}

export default TrainingProgramsSort;
